var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedIn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64795 2.49151C3.64775 2.90896 3.48172 3.30922 3.18639 3.60425C2.89107 3.89928 2.49063 4.06491 2.07319 4.0647C1.65575 4.06449 1.25548 3.89846 0.960451 3.60314C0.66542 3.30781 0.499791 2.90738 0.5 2.48994C0.500209 2.07249 0.666238 1.67223 0.961564 1.3772C1.25689 1.08217 1.65732 0.91654 2.07476 0.916748C2.49221 0.916957 2.89247 1.08299 3.1875 1.37831C3.48253 1.67364 3.64816 2.07407 3.64795 2.49151ZM3.69517 5.23023H0.547219V15.0833H3.69517V5.23023ZM8.66894 5.23023H5.53673V15.0833H8.63746V9.91281C8.63746 7.03244 12.3914 6.76486 12.3914 9.91281V15.0833H15.5V8.84251C15.5 3.98679 9.94386 4.1678 8.63746 6.55237L8.66894 5.23023Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LinkedIn.2fd2b277fe0595ae07eb0f4cd33272a3.svg";